import RunbookCollection from 'app/views/core/runbooks/RunbookCollection';

class RunbookStore {
  collection = new RunbookCollection();
}

export default new RunbookStore();
